export async function sendContactApi(data) {
  let url = "https://radevelopment.herokuapp.com/api/v1/get-contact";
  let params = {
    method: "POST",
    body: JSON.stringify(data),
    headers: {
      "Content-Type": "application/json",
    },
  };

  try {
    let res = await fetch(url, params);
    let result = res.json();
    return result;
  } catch (error) {
    console.log(error);
  }
}
